import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import DropDown from '../../../../../src/components/DropDown';
import MultiDropDown from '../../../../../src/components/MultiDropDown';
import { useData } from '../../DataContext';
import { useAssessmentContext } from './AssessmentContext';
import { useIsAssessmentAvailableMutation } from '../../../../features/authentication/assessmentApiSlice';
import { useGetAssessmentFiltersMutation } from '../../../../features/authentication/persistApiSlice';
import SkeletonGrid from '../../../../components/SkeletonLoader/SkeletonGrid';

const AssessmentFilters = () => {
  const [allCourses, setAllCourses] = useState([]);
  const [initial, setInitial] = useState(true);
  const [assessmentStatus, setAssessmentStatus] = useState([]);
  const { courseData, assignmentStatusData } = useData();
  const {
    filters,
    setFilters,
    searchText,
    setSearchText,
    setIsSearch,
    isAssessmentAvailable,
    setIsAssessmentAvailable,
    selectedAssesmentStatus,
    setSelectedAssesmentStatus,
    selectedCourseId,
    setSelectedCourseId
  } = useAssessmentContext();
  const [getFilters] = useGetAssessmentFiltersMutation();
  const [isAvailable] = useIsAssessmentAvailableMutation();

  useEffect(() => {
    checkAssessmentAvailable();
  }, []);

  const checkAssessmentAvailable = async () =>{
    const result = await isAvailable().unwrap();
    setIsAssessmentAvailable(result.isAssessmentAvailable);
  };

  useEffect(() => {
    if(isAssessmentAvailable && assignmentStatusData.length > 0 && initial)
      getassessmentFiltersAsync();
  }, [isAssessmentAvailable, assignmentStatusData]);
  
  const getassessmentFiltersAsync = async () => {
    try {
      const persistFilters = await getFilters().unwrap();
      setFilters(persistFilters); 
      setInitial(false);
      getAssessmentStatusAsync(persistFilters);
      setSelectedAssesmentStatus(persistFilters.assessmentStatus);
      setSelectedCourseId(persistFilters.courseId);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllCoursesAsync();
  }, [courseData]);

  const getAllCoursesAsync = async () => {
    try {
      const obj = {
        id: -1,
        name: 'All Courses'
      };
      const courseArray = [obj, ...courseData];
      courseArray !== null && courseArray !== undefined
        ? setAllCourses(courseArray)
        : setAllCourses([obj]);
    } catch (error) {
      console.log(error);
    }
  };

  const getAssessmentStatusAsync = async (filters) => {
    try {
      const allAssignmentStatusArray = assignmentStatusData.map((item) => ({
        ...item,
        name: replaceSpaceBeforeSecondUppercase(item.name),
        isChecked: filters.assessmentStatus.includes(item.id)
      }));
      setAssessmentStatus(allAssignmentStatusArray);
    } catch (error) {
      console.log(error);
    }
  }; 

  const replaceSpaceBeforeSecondUppercase = (text) => {
    return text.replace(/([a-z])([A-Z])/g, (match, lowercase, uppercase) => {
      return lowercase + ' ' + uppercase;
    });
  };

  const handleSelectCourse = (event) => {
    setSelectedCourseId(parseInt(event.target.value));
  };

  const handleAssessmentStatus = (e, assessmentStatus) => {
    const { key } = e;
    const selected = key !== '000' ? assessmentStatus.find((v) => v.id == key) : assessmentStatus;

    let ids = [];
    if (key === '000') {
      const tempValue = assessmentStatus.map((item) => ({
        ...item,
        isChecked: !assessmentStatus.filter((item) => item?.isChecked !== true).length < 1
      }));
      setAssessmentStatus(tempValue);
      ids = tempValue.filter((item) => item?.isChecked === true).map((itemId) => itemId.id);
    } else {
      const tempValue = assessmentStatus.map((item) =>
        item.id == key ? { ...item, isChecked: !selected.isChecked } : item
      );
      setAssessmentStatus(tempValue);
      ids = tempValue.filter((item) => item?.isChecked === true).map((itemId) => itemId.id);
    }
    setSelectedAssesmentStatus(ids);
  };

  return (
    <>
      <div className='reportBox p-4'>
        {!filters ? (
          <>
            <SkeletonGrid
              rowCount={1}
              colCount={3}
              className='p-3'/>
          </>
        ):(
          <Row>
            <Col className="col-3 mb-3">
              <DropDown
                label="Select Course"
                value={allCourses}
                onChangeHandler={(e) => handleSelectCourse(e)}
                selectedValue={selectedCourseId}
              />
            </Col>
            <Col className="col-3 mb-3 position-relative">
              <label className="form-label">Assessment Status</label>
              <MultiDropDown
                value={assessmentStatus}
                setValue={setAssessmentStatus}
                dropdownId="assessmentStatus"
                placeholder="Select Assessment Status"
                handleChange={(e) => handleAssessmentStatus(e, assessmentStatus)}
                selectedId={selectedAssesmentStatus}
                setSelectedId={setSelectedAssesmentStatus}
                selectAllText="All"
                description={true}
              />
            </Col>
            <Col className="col">
              <label className="form-label">Keyword</label>
              <div className="d-flex flex-column flex-sm-row gap-4">
                <input
                  type="text"
                  className="form-control"
                  placeholder=" "
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
                <button className="btn outline-btn btn-width" onClick={() => setIsSearch(true)}>
                Search
                </button>
              </div>
            </Col>
          </Row>
        )}
      </div>
    </>
  );
};

export default AssessmentFilters;
